export const getInfo = (currentPathname) => {
  let pathname = currentPathname || (typeof window !== "undefined" ? window.location.pathname : "/gl");

  if (pathname.startsWith("/thailand/th")) {
    pathname = pathname.replace("/thailand/th", "/th");
  }
  if (pathname.startsWith("/russia")) {
    pathname = pathname.replace("/russia", "/ru");
  }
  if (pathname.startsWith("/uzbekistan")) {
    pathname = pathname.replace("/uzbekistan", "/uz");
  }
  if (pathname.startsWith("/uganda")) {
    pathname = pathname.replace("/uganda", "/ug");
  }
  if (pathname.startsWith("/malaysia/en")) {
    pathname = pathname.replace("/malaysia/en", "/my");
  }
  if (pathname.startsWith("/ghana")) {
    pathname = pathname.replace("/ghana", "/gh");
  }
  if (pathname.startsWith("/indonesia")) {
    pathname = pathname.replace("/indonesia", "/id");
  }

  const base = pathname.split("/")[1] || "gl";
  const info = base.split("-");
  const isoCountry = (info[0] || "gl").toLowerCase();
  /*
  let isoCountry = (info[0] || "gl").toLowerCase();
  if (aliasMap[isoCountry]) {
    isoCountry = aliasMap[isoCountry];
  }*/
  const env = (info[1] || "prod").toLowerCase();
  const lang = (info[2] || "").toLowerCase();
  const pathnameNoBase = pathname.split("/").slice(2).join("/");
  // console.log('getInfo', pathname, base, info, isoCountry, env, lang, pathnameNoIsoCountry)
  return { pathname, base, isoCountry, env, lang, pathnameNoBase };
};
